export { useCookieConsent } from './useCookieConsent';
export type { CookieConsentSettings, CookieConsentState } from './useCookieConsentModel';